module.exports = __webpack_public_path__ + "img/nevill_b2.2995f18d.jpg";